import { FileDesc, Upload, UploadType } from '@wellesley/openapi'

type Source = Upload | FileDesc | UploadType

type HelperProps = {
  source: Source
  type: UploadType
}

const isUpload = (source: Source): source is Upload => {
  return (
    typeof source === 'object' &&
    source !== null &&
    'uploadId' in source &&
    'files' in source &&
    Array.isArray(source.files)
  )
}

const isFileDesc = (source: Source): source is FileDesc => {
  return (
    typeof source === 'object' &&
    source !== null &&
    'uri' in source &&
    'meta' in source &&
    'size' in source
  )
}

const isType = (source: Source): source is UploadType => {
  const types: UploadType[] = [
    'VIDEO',
    'IMAGE',
    'AUDIO',
    'DOCUMENT',
    'OTHER',
  ] as const

  return typeof source === 'string' && types.includes(source as UploadType)
}

const isUploadType = ({ source, type }: HelperProps) => {
  return isUpload(source)
    ? source.uploadType === type
    : isFileDesc(source)
      ? source.type === type
      : isType(source)
        ? source === type
        : false
}

export default isUploadType
